module.exports = __webpack_public_path__ + "static/media/medical_cert_p1_2.0a7160fa.png";